import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { AuthRedirectComponent } from './modules/auth/auth-redirect/auth-redirect.component';
 
import { MemberComponent } from './modules/member/member.component';
import { NativeGuard } from './services/native.guard';
import { BuySubscriptionComponent } from './modules/landing/buy-subscription/buy-subscription.component';
import { SocialSignUpComponent } from './modules/auth/social-sign-up/social-sign-up.component';
import { PrivacyPolicyComponent } from './modules/landing/privacy-policy/privacy-policy.component';
import { SocialAuthComponent } from './modules/auth/social-auth/social-auth.component';
import {
    DEFAULT_OG_IMAGE,
    NOINDEX_ROBOTS,
} from 'app/core/seo/seo.config';
// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to '/example'
    { path: '', pathMatch : 'full', redirectTo: 'home'},

    // Redirect signed-in user to the '/example'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    { path: 'signed-in-redirect', pathMatch : 'full', redirectTo: 'auth-redirect'},
    {
        path: 'auth-redirect', 
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: AuthRedirectComponent,
        data: {
            seo: {
                robots: NOINDEX_ROBOTS,
            },
        },
    },

    

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {
                path: 'confirmation-required',
                loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.routes'),
                data: { seo: { robots: NOINDEX_ROBOTS } },
            },
            {
                path: 'forgot-password',
                loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes'),
                data: { seo: { robots: NOINDEX_ROBOTS } },
            },
            {
                path: 'reset-password',
                loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes'),
                data: { seo: { robots: NOINDEX_ROBOTS } },
            },
            {
                path: 'sign-in',
                loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes'),
                data: { seo: { robots: NOINDEX_ROBOTS } },
            },
            {
                path: 'sign-up',
                loadChildren: () => import('app/modules/auth/sign-up/sign-up.routes'),
                data: { seo: { robots: NOINDEX_ROBOTS } },
            },
            {
                path: 'plans',
                component: BuySubscriptionComponent,
                data: {
                    seo: {
                        title: 'Subscription Plans',
                        description: 'Explore Regarding My Life subscription plans and choose the mentorship option that fits your personal growth journey.',
                        canonicalPath: '/plans/',
                        image: DEFAULT_OG_IMAGE,
                    },
                },
            },
            {
                path: 'social-sign-up',
                component: SocialSignUpComponent,
                data: { seo: { robots: NOINDEX_ROBOTS } },
            },
            {
                path: 'privacy-policy',
                component: PrivacyPolicyComponent,
                data: {
                    seo: {
                        title: 'Privacy Policy',
                        description: 'Read the Regarding My Life privacy policy and learn how personal information is collected, stored, and protected.',
                        canonicalPath: '/privacy-policy/',
                        image: DEFAULT_OG_IMAGE,
                    },
                },
            },
            {
                path: 'home/social-auth',
                component: SocialAuthComponent,
                data: { seo: { robots: NOINDEX_ROBOTS } },
            },
            {
                path: 'social-auth',
                component: SocialAuthComponent,
                data: { seo: { robots: NOINDEX_ROBOTS } },
            },
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {
                path: 'sign-out',
                loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes'),
                data: { seo: { robots: NOINDEX_ROBOTS } },
            },
            
        ]
    },

    // Landing routes
    {
        path: '',

        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'home', loadChildren: () => import('app/modules/landing-v2/home/home.routes')},
            // TASK-086 REDESIGN (ADR 0036 §4.3) — deliberately UNGATED (neither
            // AuthGuard nor NoAuthGuard): reachable whether or not the member is signed
            // in on THIS device, since the mailed link may be followed on a different
            // device than the one they registered on.
            {
                path: 'verify-email',
                loadChildren: () => import('app/modules/auth/verify-email/verify-email.routes'),
                data: { seo: { robots: NOINDEX_ROBOTS } },
            },

        ]
    },
    // Admin routes
    {
        path: 'member',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
            UserType: 'Member',
            seo: {
                robots: NOINDEX_ROBOTS,
            },
        },
        loadChildren: () => import('app/modules/member/member.routes')
        // children: [
        //     {path: '', pathMatch: 'prefix', redirectTo: 'home' },
        //     {path: 'home', loadChildren: () => import('app/modules/member/home/example.routes')},
        // ]
    },
   
];
